import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22c223c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "content-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "image-container",
  class: "d-flex align-items-center justify-content-center"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    height: "351px",
    version: "1.1",
    viewBox: "0 0 367 351",
    width: "90%",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("circle", {
        id: "path-1",
        cx: "150",
        cy: "150",
        r: "150"
      })
    ]),
    /*#__PURE__*/_createElementVNode("g", { fill: "none" }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "shadow",
        transform: "translate(34.000000, 26.000000)"
      }, [
        /*#__PURE__*/_createElementVNode("mask", {
          id: "mask-2",
          fill: "white"
        }, [
          /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#path-1" })
        ]),
        /*#__PURE__*/_createElementVNode("use", {
          id: "Mask",
          fill: "#2D8EAA",
          "fill-rule": "nonzero",
          "xlink:href": "#path-1"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          d: "M226.182933,284.629695 C227.688202,293.696878 225.161729,298.230469 218.603516,298.230469 C217.357567,298.230469 181.670284,269.486979 111.541667,212 C108.378299,212 105.833333,209.450391 105.833333,206.28125 C105.833333,203.112109 108.378299,200.5625 111.541667,200.5625 L118.601646,200.5625 C110.935679,194.523671 102.874019,188.169504 94.4166667,181.5 C88.1137153,181.5 83,176.376953 83,170.0625 L83,101.4375 C83,95.1230469 88.1137153,90 94.4166667,90 L208.583333,90 C214.886285,90 220,95.1230469 220,101.4375 C282.359375,140.743056 313.539062,160.931858 313.539062,162.003906 C313.539062,183.270833 300.672092,241.966797 294.369141,241.966797 C275.87594,272.186849 254.411097,287.296875 229.974609,287.296875 C229.826329,287.296875 228.562437,286.407815 226.182933,284.629695 Z",
          fill: "#1F6172",
          "fill-rule": "nonzero",
          mask: "url(#mask-2)"
        })
      ]),
      /*#__PURE__*/_createElementVNode("path", {
        id: "Shape",
        d: "M241.583333,115 L127.416667,115 C121.113715,115 116,120.123047 116,126.4375 L116,195.0625 C116,201.376953 121.113715,206.5 127.416667,206.5 L241.583333,206.5 C247.886285,206.5 253,201.376953 253,195.0625 L253,126.4375 C253,120.123047 247.886285,115 241.583333,115 Z M240.15625,195.0625 L128.84375,195.0625 C128.058854,195.0625 127.416667,194.419141 127.416667,193.632813 L127.416667,127.867188 C127.416667,127.080859 128.058854,126.4375 128.84375,126.4375 L240.15625,126.4375 C240.941146,126.4375 241.583333,127.080859 241.583333,127.867188 L241.583333,193.632813 C241.583333,194.419141 240.941146,195.0625 240.15625,195.0625 Z M230.166667,231.28125 C230.166667,234.450391 227.621701,237 224.458333,237 L144.541667,237 C141.378299,237 138.833333,234.450391 138.833333,231.28125 C138.833333,228.112109 141.378299,225.5625 144.541667,225.5625 L168.017188,225.5625 L172.441146,212.266406 C172.821701,211.098828 173.915799,210.3125 175.152604,210.3125 L193.871181,210.3125 C195.107986,210.3125 196.202083,211.098828 196.582639,212.266406 L201.006597,225.5625 L224.458333,225.5625 C227.621701,225.5625 230.166667,228.112109 230.166667,231.28125 Z",
        fill: "#FFFFFF",
        "fill-rule": "nonzero"
      })
    ])
  ])
], -1))
const _hoisted_3 = { id: "control-container" }
const _hoisted_4 = { id: "information-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.message), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.additionalMessage()), 1),
        (_ctx.displayResumeButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: "resume-button",
              class: "btn btn-outline-primary btn-lg",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resumeClicked && _ctx.resumeClicked(...args)))
            }, _toDisplayString(_ctx.$t('btn.resume')), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}